<template>
    <div 
        v-if="show" 
        class="gz-info-card__informers__item" 
        title="Комментарии и примечания"
        @click="openNotificationModal(modalData.url, modalData.id)"
    >
        <span class="icon-bubbles2"></span>
    </div>
</template>

<script>
import openNotificationModal from '@/mixins/ui/openNotificationModal'

export default {
    name: 'BaseCommentsAndNotes',
    
    mixins: [openNotificationModal],
    props: {
        show: {
            type: Boolean,
            default: true
        },
        modalData: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>